// image width settings
export const IMAGE_WIDTH = {
  DEFAULT: 600,
  MIN: 300,
  MAX: 1200,
};

export const IMAGE_RATIO = 2 / 3;
